import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {Card, Table, Button, Row, Col, Input, Icon, Tag, Modal, Spin, message, Tooltip} from 'antd'; 
import { Urls } from 'kts-platform-frame/entry/constant';
import Filter from './UI.CompareDetail.Filter';
import MyStore from 'kts-platform-frame/redux/MyStore';
import { InvoiceImport } from 'kts-platform-frame/display/part';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { invoiceCompare } from 'src/api';

const { formatTime, formatDate } = Field; 

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))
export default class CompareDetail extends UIBasic<IProps, ModulesState> {
    state = {
        expand: true,
        dataIn: false,
        selectedRowKeys: [],
        selectedRows: [],
    };
    columns = [

        {
            title: "发票信息",
            dataIndex: "note",
            width: 300,
            render: (text, record) => {
                return (
                    <div style={{ whiteSpace: 'nowrap' }}>
                        <div className="ui-item-description">
                            <div
                                className="ui-item-left-space"
                                title={record.supplierName}
                            >
                                <span className="supplier-name">
                                    {record.supplierName}
                                </span>
                            </div>
                            <div className="ui-item-left-space">
                                <span className="ui-item-info-tertiary">
                                    <span>发票代码 </span>
                                    <span>{record.invoiceCode}{" "}</span>
                                </span>
                                <span className="ui-item-info-tertiary">
                                    <span>发票号码 </span>
                                    <span>{record.invoiceNumber}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                );
            }
        },
        {
            title: "开票日期",
            dataIndex: 'invoiceDate',
            render: (text, record) => {
                return (
                    <span>{formatDate(record.invoiceDate)}</span>
                );
            }
        },
        {
            title: "金额",
            dataIndex: "amountWithoutTax",
            render: (text, record) => {
                return <span> {text} </span>;
            }
        },
        {
            title: "状态",
            dataIndex: "draftState",
            render: (text, record) => {
                if (record.draftStatus) {
                    return <span>
                        {123}
                    </span>;
                } else {
                    if (record.draftState === 1) {
                        return <span>
                            未提交勾选
                        </span>;
                    } else if (record.draftState === 2) {
                        return <span>
                            提交勾选成功
                        </span>;
                    } else  {
                        return (
                            <Tooltip title={record.draftMsg}>
                                <span>
                                    提交勾选失败
                                </span>
                            </Tooltip>
                        );
                    }
                    
                }
                
            }
        },
        {
            title: "上传记录",
            dataIndex: "compareStatus",
            render: (text,record) => {
                return <span>
                {text === 1 && <span><Tag color="#87d068">电子票</Tag> <Tag color="gray">实体票</Tag></span>}
                {text === 2 && <span><Tag color="#87d068">电子票</Tag><Tag color="#87d068">实体票</Tag></span>}
                {text === 3 && <span><Tag color="gray">电子票</Tag><Tag color="#87d068">实体票</Tag></span>}
            </span>;
            }
        },
        {
            title: "操作",
            dataIndex: "operate",
            className: "text-right",
            render: (text, record) => {
                return <div>
                    {
                        record.filePath!== '' && <span className="click-item" onClick={()=>{this.onViewImg(record);}}>查看文件 | </span>
                    }
                    
                    <span className="click-item" onClick={()=>{this.handleDelete(record);}}>删除</span>
                </div>;
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
        console.log(123321);
    }
    componentDidMount () {
        this.getDetail();
        this.queryBatch();
    }
    componentWillUnmount(){
        MyStore.instance.dispatch(reducers.aside.ActionTypes.hide,null);
    }
    render() {
        const extraContent = (
            <Row>
                <Col span={24} className="text-right">
                    <Button 
                        onClick={this.handleDownload}
                        disabled={this.modulesState.detailData && this.modulesState.detailData.length < 1}
                    > 
                        下载报表
                    </Button>
                    <Button 
                        className="ml-10" 
                        type="primary" 
                        onClick={this.handleCommit}
                    >
                        提交
                    </Button>
                    <Button 
                        className="ml-10" 
                        type="primary" 
                        disabled={this.state.dataIn}
                        onClick={this.showInvoiceInPanel}
                    >
                        EXCEL导入
                    </Button>
                    <Button 
                        className="ml-10" 
                        type="primary" 
                        disabled={!this.state.dataIn}
                        onClick={this.showInvoiceInPanel}
                    >
                        发票录入
                    </Button>
                    <Button 
                        icon="sync" 
                        onClick={this.refreshInvoice}
                        className="ml-10" 
                    >
                        刷新
                    </Button>
                    <Button 
                        className="ml-10" 
                        onClick={()=>{this.toggleFilter();}} 
                    >
                        筛选 <Icon type={this.state.expand ? "up" : "down"} />
                    </Button>
                </Col>
            </Row>
        );
        console.log(this.props.match.params.id);
        const {loadingUrls} = this.props;
        
        const rowSelection = {
            onSelect:(record, selected, selectedRows) => {
                console.log(selectedRows);
                this.setState({
                    selectedRows
                });
            },
            selectedRowKeys: this.state.selectedRowKeys,
            onChange:(selectedRowKeys, selectedRows) => {
                this.setState({ 
                    selectedRowKeys 
                });
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                console.log(selectedRows);
                this.setState({
                    selectedRows
                });
            },

            getCheckboxProps: record => ({
                disabled: record.invoiceNumber === '',  // Column configuration not to bechecked
            }),
        };  
        const {statistics} = this.modulesState;
        console.log('statistics', statistics);
        return (
            <div className={css.right}>
                <Card title="发票对比"  extra={extraContent}>
                    <div style={{ display: this.state.expand ? "block" : "none" }}>
                        <Row className="mb-10" style={{marginBottom: 25}}>
                            <Col span={24} >
                                <span className="text-left">
                                    <span style={{ letterSpacing: 1 }}>
                                        {/* 合计 {this.state.receiptlist && this.state.receiptlist.length} {" "}
                                        金额 <span className="bold">¥ {statistics.amountWithoutTaxTotal}</span> 
                                        | 税额 <span className="bold">¥ {statistics.amountTaxTotal}</span>  
                                        | 待对比 <span className="bold">{statistics.compareTotal} </span>  */}
                                        {" "} OCR上传总数 <span className="bold">{statistics && statistics.recognitionTotal} </span>  
                                        | 识别成功 <span className="bold">{statistics && statistics.recognitionSuccess} {" "} </span> 
                                        | 识别失败 <span className="bold">{statistics && statistics.recognitionFail} </span>
                                    </span>
                                </span>
                                
                            </Col>
                        </Row>
                        <Filter id={this.props.match.params.id}/>
                    </div>
                    <Spin spinning={loadingUrls.size > 0}>
                        <Table
                            columns={this.columns}
                            dataSource={this.modulesState.detailData}
                            rowSelection={rowSelection}
                            rowKey={'id'}
                            pagination={{
                                onChange: (page)=>{ModulesAction.handleDetailPageChange(page, this.props.match.params.id);}, 
                                defaultPageSize: 10, 
                                total: this.modulesState.detailPageTotal,
                                current: this.modulesState.detailPageNumber 
                            }}
                        />
                    </Spin>
                </Card>
            </div>
        );
    }
    
    private toggle (flag: boolean) {
        console.log(flag);
    }
    private refreshInvoice= () =>{
        this.getDetail();
        this.queryBatch();
        MyStore.instance.dispatch(reducers.aside.ActionTypes.hide,null);
    }
    private changeDataIn = () =>{
        if(this.modulesState.detailData.length > 0){
            this.modulesState.detailDataIn = true;
            this.setModulesState();
        }
    }
    private onViewImg = async(record) => {
        const data = {
            id: record.id,
        };
        const _url = await invoiceCompare.queryImgUrl(this, data); 
        const url = await _url.res.filePathUrl;
        window.open(url);
    }
    private queryBatch = () => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const userId = user.userInfo.cUserId;
        let data = {
            pageNum: 1,
            pageSize: 10,
            compareBachId:  this.props.match.params.id,
            userId,
            companyId,
        };
        ModulesAction.queryBatch(data);
    }
    private getDetail= async()=>{
        const data = {
            compareBachId: this.props.match.params.id,
            pageNumber: 1,
            pageSize: 10,
        };
        const result = await ModulesAction.getDetail(data);
        const selectedRowKeys = this.modulesState.detailData
            .filter(item => item.compareStatus === 2)
            .map(item=> item.id);
        const selectedRows = this.modulesState.detailData
            .filter(item => item.compareStatus === 2);    
        this.setState({
            selectedRowKeys,
            selectedRows
        });
        if (this.modulesState.detailData && this.modulesState.detailData.length > 0){
            this.setState({
                dataIn: true
            });
        }
    }
    private handleCommit = async()=> {
        const data = this.state.selectedRows;
        for (let i = 0; i< this.state.selectedRows.length; i++){
            data[i].invoiceCompareDetailId=data[i].id;
        }
        if (this.state.selectedRowKeys.length > 0){
            if (this.state.selectedRows.some((item)=>{return item.compareStatus !== 2;})) {
                Modal.confirm({
                     title: '提示',
                     content: '包含未成功匹配的数据，是否确认提交',
                     onOk: async() => {
                        const result = await invoiceCompare.commitCompare(this, data);
                        if (!result.er) {
                            message.info('操作成功！');
                        }
                        this.refreshInvoice();
                     }
                }); 
             } else {
                await ModulesAction.commitCompare(data);
                this.refreshInvoice();
             }
        } else {
            message.info('未勾选数据，请检查');
        }
    }
    private handleDownload = async(record) =>{
        const id = this.props.match.params.id;
        const data = {
            id1: id,
            fields: this.modulesState.detailFields,
        };
        // window.open(`${Urls["downloadInvoiceCompareResult"]}/${id}`);
         await invoiceCompare.downloadCompare(this, data);
    }
    private handleInvoice (flag: boolean) {
        console.log(flag);
    }
    private handleDelete = (record) =>{
        console.log(123123321);
        const data = {
            id: record.id
        };
    
        Modal.confirm({
            content: '确认删除本条发票？',
            onOk: async()=>{
                await ModulesAction.delCompareDetail(data);
                this.getDetail();
            }
        });
    }
    private excelUpload = info => {
        const status = info.file.status;

        if (status === 'done') {
            const returnCode = info.file.response.status.returnCode;
            if (returnCode === '99999') {
                message.warning('系统异常', 2);
            } else {
                if (info.file.response.ok) {
                    if (info.file.response.body.addResult === 1) {
                        message.info(`${info.file.response.body.addResultMsg}, 请检查！`);
                    } else {
                        let downloadFilePath = info.file.response.body.downloadFilePath;
                        if (downloadFilePath && downloadFilePath.indexOf('http') < 0) {
                            downloadFilePath = `${Urls.DOWNLOADFILE}/?filepath=${downloadFilePath}`;
                        }
                        const errorCount = info.file.response.body.errorCount;
                        const successCount = info.file.response.body.successCount;
                        this.setState({
                            excel: false,
                            errorModal: !!errorCount,
                            errorInfo: `录入成功${successCount} 条,失败${errorCount} 条!`,
                            downloadFilePath: downloadFilePath
                        });
                        if (!!errorCount === false) {
                            message.success('上传成功！');
                            this.refreshInvoice();
                        }
                    }
                    // this.props.fnForceUpdate();
                } else {
                    message.error(info.file.response.status.description);
                }

            }
        } else if (status === 'error') {
            message.error(`${info.file.name} 文件上传失败.`);
        }
    }
    private showInvoiceInPanel = () => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const downloadUrl = Urls.INVOICE_AUTH_COMPARE_TEMPLATE_DOWNLOAD; //下载路径
        const url = `${Urls.INVOICE_AUTH_ADD_COMPARE_BY_FILE}/${this.props.match.params.id}`;
        const key4url = `${Urls.INVOICE_AUTH_ADD_COMPARE_BY_FOURKEY}/${this.props.match.params.id}`;
        let urlData;
        if (this.state.dataIn){
            urlData = {
                // key4: Urls.logInvoiceMANUAL,
                key4: key4url,
                scankey4: key4url,
                scanerurl: Urls.INVOICE_AUTH_ADD_COMPARE_BY_OCR,
                scanerParams: {compareBachId: this.props.match.params.id},
            };
        } else {
            urlData = {
                downloadurl: downloadUrl,
                url: url,
                excelcallback: this.excelUpload,
            };
        }
        
        MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
            Components: <InvoiceImport urlData={urlData} refreshInvoice={()=>{this.refreshInvoice();}} />,
            title: '发票录入'
        });
    }
    private toggleFilter = () =>{
        console.log(1212121);
        this.setState({
            expand: !this.state.expand
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceCompare/UI.CompareDetail.tsx